module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter101incurringdisastertotheupperbody"
    }
  }, [_vm._v("CHAPTER 101 - INCURRING DISASTER TO THE UPPER BODY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter102blameyourwife"
    }
  }, [_vm._v("CHAPTER 102 - BLAME YOUR WIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter103shock"
    }
  }, [_vm._v("CHAPTER 103 - SHOCK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter104ameanoldladyofthezhoufamily"
    }
  }, [_vm._v("CHAPTER 104 - A MEAN OLD LADY OF THE ZHOU FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter105houseburn"
    }
  }, [_vm._v("CHAPTER 105 - HOUSE BURN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter106sacrificesoninlawtopreservethefamily"
    }
  }, [_vm._v("CHAPTER 106 - SACRIFICE SON-IN-LAW TO PRESERVE THE FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter107divorcewhenyougetback"
    }
  }, [_vm._v("CHAPTER 107 - DIVORCE WHEN YOU GET BACK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter108lowthreelowfour"
    }
  }, [_vm._v("CHAPTER 108 - LOW THREE LOW FOUR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter109conspiracy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 109 - CONSPIRACY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter110investatleast500million",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 110 - INVEST AT LEAST 500 MILLION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter111makeafoolofhimselfinpublic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 111 - MAKE A FOOL OF HIMSELF IN PUBLIC")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter112hisabilitytoturnblackintowhiteistrulyamazing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 112 - HIS ABILITY TO TURN BLACK INTO WHITE IS TRULY AMAZING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter113youareworsethananant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 113 - YOU ARE WORSE THAN AN ANT!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter114ancestralforbiddentechnique",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 114 - ANCESTRAL FORBIDDEN TECHNIQUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter115kowtowapologize",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 115 - KOWTOW APOLOGIZE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter116thisiscalledgettingwhatyouwant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 116 - THIS IS CALLED GETTING WHAT YOU WANT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter117reasonisnonsensebeforebenefit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 117 - REASON IS NONSENSE BEFORE BENEFIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter118greetingofthewealthiest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 118 - GREETING OF THE WEALTHIEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter119duepunishment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 119 - DUE PUNISHMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter120tothedeityslake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 120 - TO THE DEITY'S LAKE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter121spiritpondanddragonshadow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 121 - SPIRIT POND AND DRAGON SHADOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter122unintelligiblescene",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 122 - UNINTELLIGIBLE SCENE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter123sheisadragon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 123 - SHE IS A DRAGON")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter124aneggbespawnintenyear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 124 - AN EGG BE SPAWN IN TEN YEAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter125whatkindofwomanwouldencountersuchathing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 125 - WHAT KIND OF WOMAN WOULD ENCOUNTER SUCH A THING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter126decidetoseparatefromhim",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 126 - DECIDE TO SEPARATE FROM HIM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter127ivecometoaskyouforsomething",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 127 - I'VE COME TO ASK YOU FOR SOMETHING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter128imthebestatthreateningpeople",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 128 - I'M THE BEST AT THREATENING PEOPLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter129nomatterhowludicroustheyweretheystillhadtogiveitatry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 129 - NO MATTER HOW LUDICROUS THEY WERE THEY STILL HAD TO GIVE IT A TRY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter130pleasegivemethepowerofrevenge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 130 - PLEASE GIVE ME THE POWER OF REVENGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter131anangrygirl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 131 - AN ANGRY GIRL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter132thegreatmasterishere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 132 - THE GREAT MASTER IS HERE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter133disrespecttothemaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 133 - DISRESPECT TO THE MASTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter134likeabigtoad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 134 - LIKE A BIG TOAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter135theoriginalpricewas18000yuanbutnowits3000yuan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 135 - THE ORIGINAL PRICE WAS 18000 YUAN BUT NOW IT'S 3000 YUAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter136icanplaywithyouallday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 136 - I CAN PLAY WITH YOU ALL DAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter137gourd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 137 - GOURD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter138nomoneynoface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 138 - NO MONEY NO FACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter139takeapissandtakeyourownreflection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 139 - TAKE A PISS AND TAKE YOUR OWN REFLECTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter140luckisalwaysgood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 140 - LUCK IS ALWAYS GOOD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter141youdontknowhowtotalkyoudontknowwhatyouretalkingaboutyoupretendyoudontknowwhatyouretalkingabout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 141 - YOU DON'T KNOW HOW TO TALK YOU DON'T KNOW WHAT YOU'RE TALKING ABOUT YOU PRETEND YOU DON'T KNOW WHAT YOU'RE TALKING ABOUT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter142thelastthingineedismoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 142 - THE LAST THING I NEED IS MONEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter143iceknifeforrelievingfish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 143 - ICEKNIFE FOR RELIEVING FISH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter144allthreemillionisyours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 144 - ALL THREE MILLION IS YOURS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter145heisgoingtorenegeonthedebt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 145 - HE IS GOING TO RENEGE ON THE DEBT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter146hyperemesis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 146 - HYPEREMESIS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter147youdbetternotplaythehero",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 147 - YOU'D BETTER NOT PLAY THE HERO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter148astrangeblackout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 148 - A STRANGE BLACKOUT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter149afiancee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 149 - A FIANCEE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter150thepoweroftheblackapostlecontract",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 150 - THE POWER OF THE BLACK APOSTLE CONTRACT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter151halfofhislifeisleft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 151 - HALF OF HIS LIFE IS LEFT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter152heisaverylonelyman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 152 - HE IS A VERY LONELY MAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter153hecouldbecalledatyrantoratyrant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 153 - HE COULD BE CALLED A TYRANT OR A TYRANT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter154iwillblameallofyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 154 - I WILL BLAME ALL OF YOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter155peoplefromthejinfamilycametovisit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 155 - PEOPLE FROM THE JIN FAMILY CAME TO VISIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter156theqinfamilysrichanduselesssoninlaw",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 156 - THE QIN FAMILY'S RICH AND USELESS SON-IN-LAW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter157takechargeofthehouseinsteadofthewife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 157 - TAKE CHARGE OF THE HOUSE INSTEAD OF THE WIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter158imgonnabeyourwifeinthenextlife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 158 - I'M GONNA BE YOUR WIFE IN THE NEXT LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter159hiddencard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 159 - HIDDEN CARD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter160renegotiation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 160 - RENEGOTIATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter161makeabetonyoursonsfuture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 161 - MAKE A BET ON YOUR SON'S FUTURE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter162fromthenonhewouldneverbeabletorecover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 162 - FROM THEN ON HE WOULD NEVER BE ABLE TO RECOVER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter163unexpectedrequest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 163 - UNEXPECTED REQUEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter164somethingthatcostsmoneybutdoesnotplease",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 164 - SOMETHING THAT COSTS MONEY BUT DOES NOT PLEASE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter165anamazingsecretburiedincement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 165 - AN AMAZING SECRET BURIED IN CEMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter166youmaynotbelieveit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 166 - YOU MAY NOT BELIEVE IT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter167tothinkthathewouldhavesuchablackstomach",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 167 - TO THINK THAT HE WOULD HAVE SUCH A BLACK STOMACH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter168kunlunruins",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 168 - KUNLUN RUINS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter169limitlessaftereffects",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 169 - LIMITLESS AFTEREFFECTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter170snakehead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 170 - SNAKEHEAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter171dontyoudareplaywithme",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 171 - DON'T YOU DARE PLAY WITH ME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter172spatialfissureformation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 172 - SPATIAL FISSURE FORMATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter173fancy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 173 - FANCY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter174pickonegame",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 174 - PICK ONE GAME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter175deprivationofpower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 175 - DEPRIVATION OF POWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter176onelookatshenlangsmistakeforlife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 176 - ONE LOOK AT SHEN LANG'S MISTAKE FOR LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter177disastersorsurprises",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 177 - DISASTERS OR SURPRISES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter178inferiorhumanbeing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 178 - INFERIOR HUMAN BEING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter179idiot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 179 - IDIOT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter180whatalunatic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 180 - WHAT A LUNATIC!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter181oneafteranothertheywereshocked",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 181 - ONE AFTER ANOTHER THEY WERE SHOCKED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter182thewilloftheancestors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 182 - THE WILL OF THE ANCESTORS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter183allused",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 183 - ALL USED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter184thepriceofmourning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 184 - THE PRICE OF MOURNING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter185annulment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 185 - ANNULMENT!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter186whowouldtakeanantseriously",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 186 - WHO WOULD TAKE AN ANT SERIOUSLY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter187throwafacebook",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 187 - THROW A FACEBOOK!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter188themortalworldneedsthestrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 188 - THE MORTAL WORLD NEEDS THE STRONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter189kunluntomb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 189 - KUNLUN TOMB")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter190thequeenmotherstrueappearance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 190 - THE QUEEN MOTHER'S TRUE APPEARANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter191jasperjelly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 191 - JASPER JELLY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter192millionsofyearsofrareencounters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 192 - MILLIONS OF YEARS OF RARE ENCOUNTERS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter193doyouknowhowtousetheeighteensubduingdragonpalms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 193 - DO YOU KNOW HOW TO USE THE EIGHTEEN SUBDUING DRAGON PALMS?")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter194thejinfamilyhasbroughttheblameonthemselves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 194 - THE JIN FAMILY HAS BROUGHT THE BLAME ON THEMSELVES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter195youarenotqualified",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 195 - YOU ARE NOT QUALIFIED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter196hellhound",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 196 - HELLHOUND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter197onedayiwillfindyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 197 - ONE DAY I WILL FIND YOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter198sossms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 198 - SOS SMS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter199yourfriendisinourhands",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 199 - YOUR FRIEND IS IN OUR HANDS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter200youareherrayofsunshine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 200 - YOU ARE HER RAY OF SUNSHINE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0